export class PreferencesButtonSettings {
  constructor(overrides) {
    const defaults = {
      text: 'Button',
      width: {
        type: 'auto',
        value: 1
      },
      padding: {
        paddingLeft: 15,
        paddingRight: 15,
        paddingTop: 10,
        paddingBottom: 10
      },
      margin: {
        marginLeft: 10,
        marginRight: 10,
        marginTop: 10,
        marginBottom: 10
      },
      font: {
        fontSize: 14,
        fontWeight: '400',
        color: '#ffffff',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      background: '#1890ff',
      border: {
        borderWidth: 0,
        borderColor: '#000000',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderStyle: 'solid'
      },
      action: 0,
      languages: {},
      selectedLanguage: '',
      startFocus: false
    };
    Object.assign(this, defaults, overrides);
  }
}
export const preferencesButtonTypes = {
  text: {
    text: {
      title: 'Text',
      type: 'InputLanguage'
    },
    font: {
      title: 'Font',
      type: 'Font'
    }
  },
  dimensions: {
    width: {
      title: 'Width',
      type: 'Size'
    },
    padding: {
      title: 'Padding',
      type: 'Padding'
    },
    margin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  color: {
    background: {
      title: 'Color',
      type: 'ColorPicker'
    },
    border: {
      title: 'Border',
      type: 'Border'
    }
  },
  focus: {
    startFocus: {
      title: 'First Focused Item',
      type: 'Switch'
    }
  },
  action: {
    action: {
      title: 'Action Type',
      type: 'PreferencesActionOptions'
    }
  }
};